import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { CdnConfig } from '@app/core/model/cdn-config.model'
import { ChangeRequest } from '@app/core/model/change-request.model'
import { ScopeVersion } from '@app/core/model/scope-version'
import { ScopeActions } from '@app/features/scoping/store/actions/scoping.actions'
import { ScopeElementsService } from '@app/shared/components/scope-elements/services/scope-elements.service'
import { Store } from '@ngrx/store'
import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { ChangeItem, FetchDeliverablePayload } from '../../model'
import { MenuOptions } from '@app/core/model/definitions/menu-options.interface'
import { Dictionary } from 'lodash'
import { EditDeliverablePayload } from '../../model/edit-deliverable-payload.interface'
import { ScopeComponent } from '@app/features/scoping/models/component.model'

@Component({
  selector: 'change-request-tracked',
  templateUrl: './change-request-tracked.component.html',
})
export class ChangeRequestTrackedComponent implements OnChanges {
  @Input() currentScope: ScopeVersion
  @Input() currentChangeRequest: ChangeRequest
  @Input() changeItemsMap: Dictionary<ChangeItem>
  @Input() cdnConfig: CdnConfig
  @Input() sections: ScopeSection[]
  @Input() deliverables: Deliverable[]

  @Input() mainColumnClass: string
  @Input() componentMainColumnClass: string
  @Input() roleMainColumnClass: string

  @Output() onFetchDeliverable = new EventEmitter<FetchDeliverablePayload>()
  @Output() onEditDeliverable = new EventEmitter<EditDeliverablePayload>()
  @Output() onDeleteDeliverable = new EventEmitter<Deliverable>()
  @Output() onDeleteComponent = new EventEmitter<ScopeComponent>()

  selectedScopeId: number
  deliverableMenuOptions: MenuOptions[] = []
  componentMenuOptions: MenuOptions[] = []

  constructor(
    private store$: Store,
    protected scopeElementsService: ScopeElementsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentScope && this.currentScope && this.selectedScopeId != this.currentScope?.identity?.id) {
      this.store$.dispatch(ScopeActions.getAllFeeItems())
    }

    this.selectedScopeId = this.currentScope?.identity?.id
  }

  fetchDeliverable(deliverableId: number) {
    this.onFetchDeliverable.emit({ scopeId: this.selectedScopeId, deliverableId })
  }
}
